import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { Sparkle } from '../components/Sparkle';
import { useSeo } from '../hooks/useSeo';
const portraitSrc = 'https://cdn.magicpatterns.com/uploads/1JnA96yvxmAsPMmqRFSZq8/image.png';
const portraitAlt = 'Tina Xla mit Laptop und Hot Sales Girls Logo';
export function AboutMe() {
  useSeo({
    title: 'About Me – Tina Xla | Hot Sales Girls Academy',
    description: 'Lerne Tina Xla kennen: 15 Jahre Erfahrung im Sales, Gründerin der Hot Sales Girls Academy und Mentorin für Frauen, die als Premium-Closerin ortsunabhängig arbeiten wollen.',
    path: '/about-me',
    type: 'profile',
    image: portraitSrc
  }, {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Tina Xla',
    jobTitle: 'Gründerin der Hot Sales Girls Academy',
    image: portraitSrc,
    url: 'https://hotsalesgirls.com/about-me',
    worksFor: {
      '@type': 'Organization',
      name: 'Hot Sales Girls Academy'
    },
    sameAs: ['https://www.instagram.com/tina_xla/', 'https://www.tiktok.com/@tina_xla', 'https://www.youtube.com/@tina_xla']
  });
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-431" data-mp="3eqy13w55hht4">
      <div className="pink-panel relative" data-id="element-432" data-mp="39sczpte5ws33">
        <div className="relative z-10" data-id="element-433" data-mp="39tefgb64i2r5">
          <Navbar data-id="element-434" data-mp="350uz56g1wtin" />

          <main className="relative w-full bg-cream px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-12" data-id="element-435" data-mp="350brqjo11niv">
            <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-436" data-mp="310ul3mwv6kc4" />
            <span aria-hidden="true" className="gold-glitter-extra" data-id="element-437" data-mp="2w0yd7cl1q8ra" />
            <div className="relative z-10 mx-auto grid max-w-[1300px] items-center gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-438" data-mp="2vyvgk9pe1hdl">
              <motion.div initial={{
              opacity: 0,
              y: 24
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} className="text-center" data-id="element-439" data-mp="2m2irxq8p9tpp">
                <span className="mb-6 block text-[11px] font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-440" data-mp="2he9hzmxtuhqp">
                  Mein Warum
                </span>

                <div className="relative inline-block" data-id="element-441" data-mp="27ftrnm6mjci9">
                  <Sparkle className="animate-sparkle -left-8 -top-2 h-8 w-8" data-id="element-442" data-mp="27gbw363fwx19" />
                  <h1 className="font-sans text-4xl font-medium text-neutral-900 sm:text-5xl" data-id="element-443" data-mp="2v6fn8dzfz4bd">
                    Hi, ich bin Tina
                  </h1>
                </div>

                <img src={portraitSrc} alt={portraitAlt} className="mx-auto mt-8 w-full max-w-xl rounded-3xl border border-gold/50 object-cover shadow-2xl lg:hidden" data-id="element-444" data-mp="2mdcg0nfe3np6" />

                <div className="mt-6 space-y-4 text-sm leading-relaxed text-neutral-700 sm:text-base" data-id="element-445" data-mp="3e3gwib013ql4">
                  <p data-id="element-446" data-mp="3iwjoiep5qrz7">Sales-Expertin, Unternehmerin und Visionärin.</p>
                  <p data-id="element-447" data-mp="17f82wiw4nglv">
                    Mit 18 Jahren begann meine Reise im Door-to-Door-Vertrieb und in der Kaltakquise
                    – dort habe ich die Grundlagen des Verkaufs von Grund auf gelernt. Heute blicke
                    ich auf über 15 Jahre Erfahrung im Sales zurück, darunter High-Ticket-Sales sowie
                    der Aufbau, die Zusammenarbeit und Skalierung internationaler Sales-Teams. In
                    dieser Zeit habe ich selbst über 50 Millionen Euro eigen Umsatz im Sales generiert
                    und mit internationalen Top-Unternehmen zusammengearbeitet. Diese Erfahrung bildet
                    die Basis meiner Arbeit.
                  </p>
                  <p data-id="element-448" data-mp="tfyzkjt0sgzb">
                    Ich weiß, welche Fähigkeiten, Strukturen und Denkweisen es braucht, um sich im
                    Sales langfristig zu etablieren und weiterzuentwickeln. Mein Ziel ist es, Frauen
                    weltweit dabei zu unterstützen, ihre Sales-Skills gezielt aufzubauen oder auf das
                    nächste Level zu heben, ihre Stärken zu erkennen und selbstbewusst ihren eigenen
                    Weg im Sales zu gehen – insbesondere in einer nach wie vor männerdominierten
                    Branche. Gemeinsam arbeiten wir an Klarheit, Kompetenz und persönlichem Wachstum
                    – Schritt für Schritt und ohne leere Versprechen.
                  </p>
                </div>

                <img src="https://cdn.magicpatterns.com/uploads/61hwpEPZ2rpPcdVSiMWmCV/image.png" alt="Unterschrift von Tina Xla" className="mx-auto mt-8 w-48 sm:w-56" data-id="element-449" data-mp="xcw0m732bt1v" />
              </motion.div>

              <motion.img initial={{
              opacity: 0,
              scale: 0.97
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} src={portraitSrc} alt={portraitAlt} className="mx-auto hidden w-full max-w-xl rounded-3xl border border-gold/50 object-cover shadow-2xl lg:mt-28 lg:block lg:self-start xl:mt-0 xl:self-center" data-id="element-450" data-mp="1b4ssca0tk0xq" />
            </div>
          </main>

          <Footer data-id="element-451" data-mp="1l87vkuhmwnhp" />
        </div>
      </div>
      <CookieBanner data-id="element-452" data-mp="1l8zn9u84212p" />
    </div>;
}